module.exports = __webpack_public_path__ + "img/beta.c4fbe26f.svg";